module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MDAiIGhlaWdodD0iMzAwIiB2aWV3Qm94PSIwIDAgMjAgMTIiPjxwYXRoIGZpbGw9IiMwMDZhNGUiIGQ9Ik0wIDBoMjB2MTJIMHoiLz48Y2lyY2xlIGN4PSI5IiBjeT0iNiIgcj0iNCIgZmlsbD0iI2Y0MmE0MSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/bgd.svg
// module id = fpYD
// module chunks = 0